import type { DataGridHeaderFilter } from '../../../components/DataGrid/HeaderFilter/HeaderFilter';
import type { HeaderFilterUpdateFiltersFn } from '../../../components/DataGrid/HeaderFilterDatasource/HeaderFilterDatasource';
import type { ContentTypeDefinition } from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type GridRenderFilterEventInit = {
  /** Full path to the field within the object */
  accessor: string;
  /** Field input type */
  inputType: string;
  /** Function to update filters */
  updateFilters: HeaderFilterUpdateFiltersFn;
  /** All current filters */
  allFilters: DataGridHeaderFilter;
  /** If the filter is disabled */
  disabled: boolean;
  /** Content type that includes the field */
  contentType: ContentTypeDefinition;
};

/**
 * An event that is fired when a filter is being rendered on a top of a column.
 * Returning anything will embed that result in the column header for the field.
 *
 * @eventName "flotiq.grid.filter::render"
 * @memberof FlotiqPlugins.Events
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to replace the default renderer.
 */
export class GridRenderFilterEvent extends IFlotiqPluginEvent {
  constructor(initData: GridRenderFilterEventInit) {
    super(initData);
  }
}
